// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guideline-custom-card {
  max-width: 250px;
  background: #ffffff;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  padding: 1rem;
  margin: 0 auto 1rem;
}
.guideline-custom-card .guideline-custom-card-header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  border-radius: 6px;
}
.guideline-custom-card .guideline-custom-card-header img {
  width: 65px;
  height: 65px;
  object-fit: contain;
}
.guideline-custom-card .guideline-custom-card-body {
  padding-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.guideline-custom-card .guideline-custom-card-body .guideline-custom-card-title {
  font-family: "Roboto", "SolaimanLipi", sans-serif;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 0.95rem;
  color: #08245A;
}
.guideline-custom-card .guideline-custom-card-body .pdf-download-btn {
  margin-left: 1rem;
}
.guideline-custom-card .guideline-custom-card-body .pdf-download-btn:hover, .guideline-custom-card .guideline-custom-card-body .pdf-download-btn:focus {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pages/guidelines/sections/guidelineCardStyle.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AACN;AAGE;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,iDAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AADN;AAII;EACE,iBAAA;AAFN;AAIM;EAEE,qBAAA;AAHR","sourcesContent":[".guideline-custom-card {\r\n  max-width: 250px;\r\n  background: #ffffff;\r\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);\r\n  border-radius: 6px;\r\n  padding: 1rem;\r\n  margin: 0 auto 1rem;\r\n\r\n  .guideline-custom-card-header {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 150px;\r\n    border-radius: 6px;\r\n\r\n    img {\r\n      width: 65px;\r\n      height: 65px;\r\n      object-fit: contain;\r\n    }\r\n  }\r\n\r\n  .guideline-custom-card-body {\r\n    padding-top: 1rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    .guideline-custom-card-title {\r\n      font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n      margin-bottom: 0;\r\n      font-weight: 500;\r\n      font-size: .95rem;\r\n      color: #08245A;\r\n    }\r\n\r\n    .pdf-download-btn {\r\n      margin-left: 1rem;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        text-decoration: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
